import React, { useMemo, useState } from 'react';
import { sanitizeScriptsFromPdf } from '~/utils/forms.ts';

type PdfObjectProps = {
  id?: string;
  src?: string;
  blob?: Blob;
  height?: number | string;
  width?: number | string;
  emptyObjectClass?: string;
};

export const PdfObject: React.FC<PdfObjectProps> = ({
  id,
  src,
  blob,
  height,
  width,
  emptyObjectClass,
}) => {
  const [fileBlob, setFileBlob] = useState<Blob | undefined>(blob);

  const objectSrc = useMemo(
    () => (fileBlob ? URL.createObjectURL(fileBlob) : undefined),
    [fileBlob],
  );

  if (src && !fileBlob) {
    const getFile = async (): Promise<Blob> => {
      const response = await fetch(src);
      const sanitizedPdfArrayBuffer = await sanitizeScriptsFromPdf(
        await response.arrayBuffer(),
      );
      const pdfBlob = new Blob([sanitizedPdfArrayBuffer], {
        type: 'application/pdf',
      });
      return pdfBlob;
    };
    getFile().then((pdfBlob) => setFileBlob(pdfBlob));
  }

  if (!objectSrc) {
    // render a blank thumbnail
    return <div className={emptyObjectClass} style={{ height, width }} />;
  }

  return (
    <object
      id={id}
      data={objectSrc}
      type="application/pdf"
      data-test-id="PdfObject"
      height={height}
      width={width}
    >
      <p>PDF file</p>
    </object>
  );
};
